import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, type GetPlanActionItemsDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetPlanActionItemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getPlanActionItemsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.plans.getPlanActionItems>>): Promise<GetPlanActionItemsDto> {
    const accessToken = await getAccessToken();
    const [{ slug }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/teams/${slug}/action-items`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getPlanActionItemsRequest };
};

const useGetPlanActionItems = (slug: string | undefined) => {
  const { getPlanActionItemsRequest } = useGetPlanActionItemsRequest();

  return useQuery({
    queryKey: queryKeys.plans.getPlanActionItems(slug),
    queryFn: getPlanActionItemsRequest,
    enabled: slug !== undefined,
  });
};

export { useGetPlanActionItems };
